import { useEffect, useState } from 'react'
import styles from './Footer.module.css'

const YEAR = new Date().getFullYear()

const IconArrowUp = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </svg>
)

const IconGitHub = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z" />
  </svg>
)

const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
)

const IconX = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
)

interface SocialItem {
  href: string
  label: string
  icon: React.ReactNode
}

const SOCIALS: SocialItem[] = [
  { href: 'https://github.com/StevenYAMBOS', label: 'GitHub', icon: <IconGitHub /> },
  { href: 'https://www.linkedin.com/in/steven-yambos', label: 'LinkedIn', icon: <IconLinkedIn /> },
  { href: 'https://x.com/StevenYambos', label: 'X (Twitter)', icon: <IconX /> },
]

export function Footer() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: 'smooth' })

  return (
    <>
      {/* ── Footer ── */}
      <footer className={styles.footer} role="contentinfo">
        <div className={styles.inner}>
          {/* Logo */}
          <a href="/" className={styles.logo} aria-label="Retour en haut de page">
            SY.
          </a>

          {/* Copyright */}
          <p className={styles.copy}>
            © {YEAR}{' '}
            <a
              href="https://stevenyambos.fr"
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Steven YAMBOS
            </a>
          </p>

          {/* Liens sociaux */}
          <nav className={styles.socials} aria-label="Réseaux sociaux">
            {SOCIALS.map(({ href, label, icon }) => (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className={styles.socialLink}
              >
                {icon}
              </a>
            ))}
          </nav>
        </div>

        {/* Ligne décorative */}
        <div className={styles.line} aria-hidden="true" />
      </footer>

      {/* ── Scroll to top ── */}
      <button
        type="button"
        onClick={scrollToTop}
        aria-label="Revenir en haut de page"
        className={`${styles.scrollTop} ${visible ? styles.scrollTopVisible : ''}`}
      >
        <IconArrowUp />
      </button>
    </>
  )
}